<div class="long-title">
  <h4 class="content-block ap-green">Add/Edit Contract</h4>
</div>
<div id="form-container">
  <form class="login-form" (submit)="handleSubmit($event)">
      <dx-form id="form" [colCount]="12" [formData]="contractItem" [showColonAfterLabel]="true" [showValidationSummary]="true">
          <dxi-item dataField="customer" [colSpan]="8" [editorOptions]="{ readOnly: true } ">
              <dxi-validation-rule type="required" message="Customer Site is required"></dxi-validation-rule>
          </dxi-item>
          <dxi-item [colSpan]="4" cssClass="extraPadding">
              <dx-button text="Search Customers" type="default" [useSubmitBehavior]="false" (onClick)="openPopup()"></dx-button>
          </dxi-item>
          <dxi-item dataField="supplier" editorType="dxSelectBox" [colSpan]="6" [label]="{ text: 'Supplier' }"
                    [editorOptions]="{ items: suppliers, searchEnabled: true, displayExpr: 'supplierName', valueExpr: 'supplierName' }">
              <dxi-validation-rule type="required" message="Supplier is required"></dxi-validation-rule>
          </dxi-item>

        <dxi-item dataField="awardYear"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Award Year' }"
                    [colSpan]="6"
                    [editorOptions]="{ items: awardYears, searchEnabled: true, displayExpr: '', valueExpr: ''  }">
          </dxi-item>

          <dxi-item dataField="materialId"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Material' }"
                    [colSpan]="6"
                    [editorOptions]="{ items: materials, searchEnabled: true, displayExpr: 'materialName', valueExpr: 'materialId'  }">
              <dxi-validation-rule type="required" message="Material is required"></dxi-validation-rule>
          </dxi-item>

        <dxi-item dataField="term" [colSpan]="6">
            <dxi-validation-rule type="pattern" [pattern]="numberPattern" message="Only whole numbers are allowed">
            </dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="quantity" [colSpan]="3">
            <dxi-validation-rule type="pattern" [pattern]="decimalOnePlace" message="Only numerics with one decimal place is allowed">
            </dxi-validation-rule>
        </dxi-item>

          <dxi-item dataField="quantityUom"
                    editorType="dxSelectBox"
                    [colSpan]="3"
                    [editorOptions]="{ items: quantityUoms, searchEnabled: true, displayExpr: '', valueExpr: ''  }"></dxi-item>

        <dxi-item dataField="commenceYear"
                    editorType="dxSelectBox"
                    [colSpan]="6"
                    [editorOptions]="{ items: awardYears, searchEnabled: true, displayExpr: '', valueExpr: ''  }">
          </dxi-item>

        <dxi-item dataField="price" [colSpan]="3">
            <dxi-validation-rule type="pattern" [pattern]="decimalTwoPlaces" message="Only numerics with two decimal places are allowed"></dxi-validation-rule>
        </dxi-item>

          <dxi-item dataField="quantityUom"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Currency' }"
                    [colSpan]="3"
                    [editorOptions]="{ items: priceUoms, searchEnabled: true, displayExpr: '', valueExpr: ''  }"></dxi-item>

        <dxi-item dataField="expireYear"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Expire Year' }"
                    [colSpan]="6"
                    [editorOptions]="{ items: awardYears, searchEnabled: true, displayExpr: '', valueExpr: ''  }">
          </dxi-item>

          <dxi-item dataField="supplyMode"
                    editorType="dxSelectBox"
                    [colSpan]="4"
                    [editorOptions]="{ items: supplyModes, searchEnabled: true, displayExpr: '', valueExpr: ''  }"></dxi-item>
          <dxi-item [colSpan]="2"></dxi-item>
        <dxi-item dataField="annualRevenue" [colSpan]="6" [label]="{ text: 'Annual Contract Revenues (USD)' }">
            <dxi-validation-rule type="pattern" [pattern]="decimalTwoPlaces"
                message="Only numerics with two decimal places are allowed"></dxi-validation-rule>
        </dxi-item>

          <dxi-item dataField="notes"
                    editorType="dxTextArea"
                    [label]="{ text: 'Contract Notes' }"
                    [editorOptions]="{ height: 120 }"
                    [colSpan]="12"></dxi-item>

          <dxi-item itemType="button" [buttonOptions]="{ text: 'Save Close', type:'success', useSubmitBehavior: true }">
          </dxi-item>
          <dxi-item>
              <dx-button text="Cancel" type="danger" (onClick)="resetFilters()">
              </dx-button>
          </dxi-item>
      </dx-form>
  </form>

</div>
<customer-site [buttonTrigger]="popupVisible" (setPopupVisibility)="setPopupVisibility($event)"
    (setSiteId)="setSiteId($event)" (setCustomer)="setCustomer($event)"></customer-site>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
             [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>